import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import ModalVideo from 'react-modal-video';

import { selectCourses } from '../../../redux/features/course-slice';
import RelatedMateria from './../materia/related-materia';
import {cart_course} from '../../../redux/features/cart-slice';
import { Link } from 'react-router-dom';

const MateriaDetailsArea = ({ cursos, materias, materia, course }) => {
  // all courses
  const courses = useSelector(selectCourses);
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false)
  
  if (materia !== null)  {

  return (
    <>
    {/* video modal start */}
    <ModalVideo channel='youtube' autoplay isOpen={isOpen} 
    videoId={course.y_video_id} onClose={() => setOpen(false)} />
    {/* video modal end */}

      <section className="page__title-area pt-120 pb-90">
        {/* <div className="page__title-shape">
          <img className="page-title-shape-5 d-none d-sm-block" 
          src="/assets/img/page-title/page-title-shape-1.png" alt="" />
          <img className="page-title-shape-6" src="/assets/img/page-title/page-title-shape-6.png" alt="" />
          <img className="page-title-shape-7" src="/assets/img/page-title/page-title-shape-4.png" alt="" />
        </div> */}
        <div className="container">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12">
              <div className="course__wrapper">
                <div className="page__title-content mb-25">
                  <div className="page__title-breadcrumb">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Principal</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">{materia.nome}</li>
                      </ol>
                    </nav>
                  </div>
                  {/* <span className="page__title-pre">{course.category}</span> */}
                  <h5 className="page__title-3" style={{ marginBottom: '50px' }}>Cursos: {materia.nome}</h5>
                </div>
                
               
                <div className="course__tab-content mb-95">
                  <div className="tab-content" id="courseTabContent">
                    <div className="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="description-tab">
                      <div className="course__description">
                        
                        <div className="row grid">
                        
                        { (cursos.length == 0) ? <><p>Nenhum Curso foi encontrado, tente outro segmento.</p></> : '' }

                        {cursos.map((curso, index) => (
                          <div key={index} className="col-xxl-3 col-xl-3 col-lg-3 col-md-4">
                            <div className="course__item white-bg mb-30 fix">
                              <div className="course__thumb w-img p-relative fix">
                                <Link to={`/curso/${curso.cd_curso}`}>
                                  <img src={"https://v1.profaprizattera.com.br/uploads/curso/" + curso.file} alt="" />
                                </Link>
                                
                              </div>
                              <div className="course__content">
                                <div className="course__meta d-flex align-items-center justify-content-between">
                                
                                </div>
                                <h3 className="course__title">
                                  <Link to={`/curso-detalhes/${curso.cd_curso}`}>{curso.nome}</Link>
                                </h3>
                                
                              </div>
                              <div className="course__more d-flex justify-content-between align-items-center">
                                
                                <div className="course__btn">
                                  <Link to={`/curso-detalhes/${curso.cd_curso}`} className="link-btn">
                                    Saiba mais
                                    <i className="far fa-arrow-right"></i>
                                    <i className="far fa-arrow-right"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                        
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div className="course__related">
                  <div className="row">
                    <div className="col-xxl-12">
                      <div className="section__title-wrapper mb-40">
                        <h2 className="section__title">Outras <span className="yellow-bg yellow-bg-big">Áreas<img src="/assets/img/shape/yellow-bg.png" alt="" /></span></h2>
                        <p>Vamos juntos direcionar seus estudos para um melhor resultado.</p>
                      </div>
                    </div>
                  </div>
                  <div className="row grid">
                        {materias.map((materia, index) => (
                          <div key={index} className="col-xxl-3 col-xl-3 col-lg-3 col-md-4">
                            <div className="course__item white-bg mb-30 fix">
                              <div className="course__thumb w-img p-relative fix">
                                
                                <a href={`/materia/${materia.cd_materia}`}>
                                  <img src={"https://v1.profaprizattera.com.br/uploads/materia/" + materia.file} alt="" />
                                </a> 
                                
                              </div>
                              <div className="course__content">
                                <div className="course__meta d-flex align-items-center justify-content-between">
                                
                                </div>
                                <h3 className="course__title">
                                  <a href={`/materia/${materia.cd_materia}`}>{materia.nome}</a>
                                </h3>
                                
                              </div>
                              <div className="course__more d-flex justify-content-between align-items-center">
                                
                                <div className="course__btn">
                                  <a href={`/materia/${materia.cd_materia}`} className="link-btn">
                                    Saiba mais
                                    <i className="far fa-arrow-right"></i>
                                    <i className="far fa-arrow-right"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </section>
    </>
  );
  }
};

export default MateriaDetailsArea;